import { render, staticRenderFns } from "./Clues.vue?vue&type=template&id=a9e35c7e&"
import script from "./Clues.vue?vue&type=script&lang=js&"
export * from "./Clues.vue?vue&type=script&lang=js&"
import style0 from "./Clues.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports